import * as _ from 'lodash';
import { getAllCityOptions, getCityStreetsOptions } from '../../api/MeitavDashApi';

function _convertCityToUIOption(city) {
  return {
    label: city.cityName,
    value: city.cityId,
  };
}

function _convertStreetToUIOption(street) {
  return {
    label: street,
    value: street,
  };
}

const state = {
  chosenCity: '',
  cities: [],
  streets: [],
};

const actions = {
  async initCityAndStreetList({ commit, dispatch }, city) {
    const cities = await getAllCityOptions();
    const cityOptions = _.map(cities, _convertCityToUIOption);
    commit('setCities', cityOptions);
    if (city && city.label) {
      dispatch('setChosenCityForStreetsOptions', city.label);
    }
  },
  async setChosenCityForStreetsOptions({ commit }, city) {
    commit('setChosenCity', city);
    const cityStreets = await getCityStreetsOptions(city);
    const streetOptions = _.map(cityStreets, _convertStreetToUIOption);
    commit('setStreets', streetOptions);
  },
};

const mutations = {
  setCities(state, cities) {
    state.cities = cities;
  },
  setStreets(state, streets) {
    state.streets = streets;
  },
  setChosenCity(state, city) {
    state.chosenCity = city;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
